import { ChevronDown } from 'lucide-react';
import { StepCircle } from './StepCircle';
import styles from './SectionHeader.module.css';

interface SectionHeaderProps {
  n: number;
  done: boolean;
  title: string;
  estimate: string;
  onCollapse?: () => void;
}

export function SectionHeader({ n, done, title, estimate, onCollapse }: SectionHeaderProps) {
  return (
    <div
      onClick={onCollapse}
      className={`${styles.header} ${onCollapse ? styles.headerClickable : ''}`}
    >
      <StepCircle n={n} done={done} />
      <span className={styles.title}>{title}</span>
      <span className={styles.estimate}>{estimate}</span>
      {onCollapse && (
        <span className={styles.collapseIcon}>
          <ChevronDown size={16} />
        </span>
      )}
    </div>
  );
}
